import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import CheckedOff from '@material-ui/icons/RadioButtonUncheckedOutlined';
import CheckedOn from '@material-ui/icons/CheckCircle';
import { FormControlLabel, Checkbox, Paper, List, Tooltip } from '@material-ui/core';
import { getSubsidiaryPages, getSubsidiaryPagesUnderPage } from '../../../actions/admin/pageAction';
import OverLoading from '../../global/OverLoading';
import Constants from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#000',
    color:           '#FFF',
    maxWidth:        220,
    marginTop:       -20,
    fontSize:        theme.typography.pxToRem(15),
    border:          '1px solid #dadde9',
  },
}))(Tooltip);

const checkStyleOn = {
  position:     'absolute',
  right:        5,
  bottom:       5,
  background:   '#FFF',
  color:        '#3adf2f',
  borderRadius: '100%',
  boxShadow:    '0px 0px 9px 3px rgb(58, 223, 47)',
};

const checkStyleOff = {
  position:     'absolute',
  right:        5,
  bottom:       5,
  background:   'rgb(255 255 255 / 0.70)',
  color:        '#000000',
  borderRadius: '100%',
};

let selectedItems = [];

class PromoSubsidiary extends Component {
  constructor(props) {
      super(props);
      this.state = {
        isLoading:     true,
        checkBoxState: false,
        subdisiaries:  [],
      };
  }

  componentDidMount() {
    // IS PARENT && NON-CC PAGE TYPE
    if (this.props.page.parentId === null && this.props.page.type !== Constants.PageType.CreditCard) {
      // This is a Parent page fetching for child pages.
      const fetchPromoSubsidiariesByParent = async (id) => {
        const fetchChildren = await this.props.getSubsidiaryPagesUnderPage(id);
        const data = _.sortBy(_.map(fetchChildren, _.partialRight(_.pick, ['id', 'name', 'logo', 'permanentlyClosed'])), 'name');
        const currentSubsidiaryPages = this.props.promoSubsidiariesData;
          // set subdisiaries data.
          this.setState({ subdisiaries: data }, () => { this.setState({ isLoading: false }); });

          if (fetchChildren.length > 0) {
            _.forEach(currentSubsidiaryPages, (value) => {
              if (!value.permanentlyClosed) {
                if (_.some(selectedItems, { id: value.id, name: value.name }) === false) {
                  selectedItems.push({ id: value.id, name: value.name, logo: value.logo, permanentlyClosed: value.permanentlyClosed });
                }
              }
            });

            this.setState({ isLoading: true }, () => {
              this.setState({ isLoading: false });
              this.onSubsidiaryChanged(selectedItems);
            });
          }
      };
      fetchPromoSubsidiariesByParent(this.props.page.id);
    } /*else {
        // DO NOT REMOVE.
        // IS PARENT && CC PAGE TYPE
        const fetchPromoSubsidiaries = async () => {
          const allPromoSubsidiaries = await this.props.getSubsidiaryPages();
          const data = _.map(allPromoSubsidiaries, _.partialRight(_.pick, [ 'id', 'name', 'logo']));
          const promoSubsidiariesData = this.props.promoSubsidiariesData;

          // set subsidiary data.
          this.setState({ subdisiaries: data }, () => { this.setState({ isLoading: false }) });

          if( data.length > 0 ) {
            var self = this;
            // pass a postId to fetch existing data.
            if(promoSubsidiariesData.length > 0) {
              _.forEach(promoSubsidiariesData, function(value, key) {
                // check if fetch data exist in state if yes, push as Selected item.
                const checkIfFetchDataExist = _.some( data, { id: value.id, name: value.name });
                if(checkIfFetchDataExist){
                  if( _.some( selectedItems, { id: value.id }) === false ) {
                    selectedItems.push({ id: value.id, name: value.name, logo: value.logo });
                    self.setState({ isLoading: true }, () => {
                      self.setState({ isLoading: false });
                      self.onSubsidiaryChanged(selectedItems);
                    });
                  }
                }
              });
            }
          }
        }
        fetchPromoSubsidiaries();
      } */
  }

  componentWillUnmount() {
    if (!IsEmpty(selectedItems)) {
      selectedItems = [];
    }
  }

  onSubsidiaryChanged = (data) => {
    this.props.onSubsidiaryChanged(data);
  }

  handleSelected = (data) => {
    this.setState({ isLoading: true });

    const isDataAlrSelected = _.some(selectedItems, { id: data.id, name: data.name });
    if (isDataAlrSelected === true) {
      _.remove(selectedItems, { id: data.id });
      this.setState({ isLoading: false });
    } else {
      selectedItems.push(data);
      this.setState({ isLoading: false });
    }

    this.onSubsidiaryChanged(selectedItems);
  }

  handleSelectAll = () => {
    this.setState({ isLoading: true });

    if (this.state.checkBoxState) {
      this.setState({ checkBoxState: false }, () => {
        selectedItems.splice(0, selectedItems.length);
        this.setState({ isLoading: false });
      });
    } else {
      this.setState({ checkBoxState: true }, () => {
        this.state.subdisiaries.map((data) => {
          selectedItems.push(data);
        });
        this.setState({ isLoading: false });
      });
    }
    this.onSubsidiaryChanged(selectedItems);
  }

  render() {
    const stateSubsidiaries = this.state.subdisiaries;
    return (
      <div>
        { stateSubsidiaries.length > 0 && (
          <FormControlLabel
            control={<Checkbox checked={this.state.checkBoxState} onChange={this.handleSelectAll} />}
            label={this.state.checkBoxState ? 'Deselect' : 'Select All'}
          />
        )}

        <div className="float-right" style={{ fontSize: '18px' }}>
          Selected
          {' '}
          <span style={{ background: '#d12c2c' }} className="badge badge-secondary">
            { selectedItems.length }
            {' '}
            /
            {' '}
            { stateSubsidiaries.length }
          </span>
        </div>

        { this.state.isLoading && <OverLoading /> }
        <Paper style={{ maxHeight: 350, width: '100%', padding: 20, overflow: 'auto' }}>
          <List>
            { stateSubsidiaries.length > 0 && !this.state.isLoading
              ? (
                <div className="row">
                  { stateSubsidiaries.map((data, index) => (
                    <HtmlTooltip title={data.permanentlyClosed ? `${data.name} is permanently closed` : data.name} key={index}>
                      <div onClick={() => this.handleSelected(data)} className="col-md-2 mb-5">
                        <div style={{
                          position:     'relative',
                          background:   '#EEE',
                          opacity:      `${data.permanentlyClosed ? 0.3 : 1}`,
                          cursor:       `${data.permanentlyClosed ? 'no-drop' : 'pointer'}`,
                          width:        85,
                          height:       85,
                          border:       '1px outset #CCC',
                          borderRadius: 5 }}
                        >
                          {
                            data.logo
                              ? <img src={data.logo} alt={data.name} style={{ borderRadius: 5, cursor: 'pointer', width: 85, height: 'auto' }} />
                              : <div><p style={{ textAlign: 'center', lineHeight: '85px', fontSize: 45 }}>{ data.name.charAt(0) }</p></div>
                          }
                          { _.some(selectedItems, { id: data.id }) === true && !data.permanentlyClosed
                            ? <CheckedOn style={checkStyleOn} />
                            : <CheckedOff style={checkStyleOff} />}
                        </div>
                        <span style={{ display: 'block', marginTop: 10, fontSize: '11px', fontWeight: 'bold', color: '#000000' }}>{ data.name }</span>
                      </div>
                    </HtmlTooltip>
                  ))}
                </div>
              )
              : 'There are no subsidiaries under this brand.' }
          </List>
        </Paper>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getSubsidiaryPages:          (id) => dispatch(getSubsidiaryPages(id)),
  getSubsidiaryPagesUnderPage: (id) => dispatch(getSubsidiaryPagesUnderPage(id)),
});

PromoSubsidiary.propTypes = {
  page: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ])).isRequired,
  promoSubsidiariesData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ])).isRequired,
  getSubsidiaryPagesUnderPage: PropTypes.func.isRequired,
  onSubsidiaryChanged:         PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(PromoSubsidiary);
